import { SEOHead } from '@/components/seo';
import { PAGE_SEO } from '@/lib/seo-config';

export default function Privacy() {
  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <SEOHead
        title={PAGE_SEO.privacy.title}
        description={PAGE_SEO.privacy.description}
        keywords={PAGE_SEO.privacy.keywords}
        url="/legal/privacy"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Privacy Policy', url: '/legal/privacy' },
        ]}
      />
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 data-testid="privacy-title" className="text-4xl font-bold text-white mb-4 section-marker font-mono">Privacy Policy</h1>
          <p className="text-xs font-mono text-zinc-500 mb-12">Last updated: February 1, 2026</p>
          <div className="space-y-8">
            {[
              { title: 'Information We Collect', body: 'We collect account information (name, email, company), billing information (processed securely via Stripe), usage analytics (anonymized), and technical logs for debugging.' },
              { title: 'How We Use Your Data', body: 'Your data is used to provide and improve the Service, process payments, send service-related communications, and ensure security. We never sell your personal data.' },
              { title: 'Instance Data', body: 'Your OpenClaw instance data (messages, memories, files) remains on your dedicated VPS. We do not access, read, or analyze your instance data unless explicitly requested for support.' },
              { title: 'Data Encryption', body: 'All data is encrypted at rest (AES-256) and in transit (TLS 1.3). API keys stored on our platform are additionally encrypted with per-user keys.' },
              { title: 'Data Retention', body: 'Account data is retained while your account is active. After deletion, data is purged within 30 days. Backups are retained per your plan settings.' },
              { title: 'Third Parties', body: 'We use Stripe for payments, AWS/Hostinger for infrastructure, and standard analytics tools. Each processes only the minimum data required.' },
              { title: 'Your Rights', body: 'You can access, export, correct, or delete your data at any time via Settings. For GDPR requests, contact privacy@clawstinger.com.' },
              { title: 'Contact', body: 'For privacy-related questions, email privacy@clawstinger.com.' },
            ].map((s, i) => (
              <div key={i}>
                <h2 className="text-lg font-mono text-white font-bold mb-2">{s.title}</h2>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
